import React from "react";
import T from "prop-types";
import { Spinner } from "..";
import { Button } from "@mui/material";

export const ActionButton2 = ({ text, className, onClick, isLoading, marginTop, disabled, type, style,color }) => (
    <Button 
    sx={{  color: color,fontSize:'11px' }}
    variant="contained" startIcon={isLoading ? (
        <Spinner size={20} color="white" loading={isLoading} style={{ marginTop: marginTop }} />
    ) : (
        null
    )}
     className={className} onClick={onClick} disabled={disabled} type={type} style={style}>
       
    <span style={{color:color}}>{text}</span>
       
    </Button>
);

ActionButton2.T = {
    onClick: T.func,
    className: T.string,
    text: T.string
};

ActionButton2.defaultProps = {
    onClick: null,
    className: "primaryButtonCls",
    text: ""
};
